import React, { useEffect, useState, useRef } from "react";
import "./styletechs.css";
import { RightAnchor } from "../../components/rightAnchor";
import { TopMenu } from "../../components/topmenu/TopMenu";

export function TechList(props) {
  const tech1 = useRef(null);
  const tech2 = useRef(null);
  const tech3 = useRef(null);
  const tech4 = useRef(null);
  const tech5 = useRef(null);
  const tech6 = useRef(null);
  const [domId, setDomId] = useState(null);
  useEffect(() => {
    let { hash } = props.location;
    if (hash) {
      setDomId(hash.slice(1));
      let dom = hash.slice(1);
      switch (dom) {
        case "tech1":
          window.scrollTo(0, tech1.current.offsetTop);
          break;
        case "tech2":
          window.scrollTo(0, tech2.current.offsetTop);
          break;
        case "tech3":
          window.scrollTo(0, tech3.current.offsetTop);
          break;
        case "tech4":
          window.scrollTo(0, tech4.current.offsetTop);
          break;
        case "tech5":
          window.scrollTo(0, tech5.current.offsetTop);
          break;
        case "tech6":
          window.scrollTo(0, tech6.current.offsetTop);
          break;
        default:
          window.scrollTo(0, tech1.current.offsetTop);
          break;
      }
    } else {
      setDomId("tech1");
      window.scrollTo(0, tech1.current.offsetTop);
    }
  }, []);
  return (
    <div className="TechList">
      <TopMenu />
      <div id="tech1" ref={tech1} className="techs_div">
        <div className="tech_list_item" data-animeff="linear" data-duration="1">
          <div
            className="tech_list_txt"
            data-animation="once"
            comporinalwidth="690"
            comporinalleft="869"
            originaled="true"
            animated="true"
          >
            <div
              className="tech_txt_wrap"
              animation_name="fadeInUp"
              animation_duration="1s"
              animation_delay="1s"
            >
              <div className="e_rbox e_Rbox-000 p_rbox">
                <div className="tech_list_context reset_style">
                  <div
                    animation_name="none"
                    animation_duration="0s"
                    animation_delay="0s"
                  >
                    <p>
                      <span className="tech_lc_txt">
                        人类发射的第一颗雷达卫星就是海洋卫星。合成孔径雷达（SAR）自诞生以来，凭借其实时、大范围、多频次、全天时、全天候监测等特点，已经被广泛应用于探测海浪、海流、海冰和风场、溢油污染、海岸变迁及船舶检测，在海事安全管理和海洋科学研究领域发挥了重要的作用，成为海洋监测中不可替代的监测方式。
                      </span>
                    </p>
                    <p>
                      <span className="">&nbsp;</span>
                    </p>
                    <p>
                      <span className="tech_lc_txt_t">
                        <strong>●溢油监测</strong>
                      </span>
                    </p>
                    <p>
                      <span className="tech_lc_txt">
                        通过SAR图像上油与水的后向散射系数差异，可以识别海面溢油污染、估算污染范围、监测污染扩散。
                      </span>
                    </p>
                    <p>
                      <span className="">&nbsp;</span>
                    </p>
                    <p>
                      <span className="tech_lc_txt_t">
                        <strong>●船只检测</strong>
                      </span>
                    </p>
                    <p>
                      <span className="tech_lc_txt">
                        在一定海面风速和海况条件下，SAR图像能较容易地获取海面船只的位置、大小、航行方向和速度等信息，可以用于海洋军事、航道监测和遇难船只救助等方面。
                      </span>
                    </p>
                    <p>
                      <span className="">&nbsp;</span>
                    </p>
                    <p>
                      <span className="tech_lc_txt_t">
                        <strong>●海冰监测</strong>
                      </span>
                    </p>
                    <p>
                      <span className="tech_lc_txt">
                        SAR的多极化、多视角、穿透性强等特点，使其在海冰动态监测和分类中得到了广泛的应用，可服务于船舶航行安全和海洋气候研究。
                      </span>
                    </p>
                    <p>
                      <span className="">&nbsp;</span>
                    </p>
                    <p>
                      <span className="tech_lc_txt_t">
                        <strong>●海浪与内波探测</strong>
                      </span>
                    </p>
                    <p>
                      <span className="tech_lc_txt">
                        利用SAR图像可以直接导出波长、波向、波的折射和绕射、内波等海浪信息，可应用于海浪预报、海洋工程和物理海洋学。
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="tect_list_name reset_style"
            comporinalwidth="488"
            comporinalleft="360"
            originaled="true"
          >
            <div
              animation_name="none"
              animation_duration="0s"
              animation_delay="0s"
            >
              <p>
                <span className="tect_ln_txt">
                  海洋监测 /&nbsp;Marine monitoring
                </span>
              </p>
            </div>
          </div>
          <div
            className="tech_list_pic w_img-002"
            comporinalwidth="569"
            comporinalleft="360"
            originaled="true"
          >
            <div
              animation_name="none"
              animation_duration="1s"
              animation_delay="0s"
            >
              <div className="e_box e_box-000 p_box">
                <a className="e_link e_link-000 p_link001" target="_blank">
                  <div className="e_image e_DImage-001 p_dimage">
                    <img
                      src="./img/g1.jpg"
                      alt=""
                      title=""
                      width="100%"
                      height="100%"
                    />
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="tech2" ref={tech2} className="techs_div">
        <div className="tech_list_item" data-animeff="linear" data-duration="1">
          <div
            className="tech_list_txt"
            data-animation="once"
            comporinalwidth="690"
            comporinalleft="869"
            originaled="true"
            animated="true"
          >
            <div
              className="tech_txt_wrap"
              animation_name="fadeInUp"
              animation_duration="1s"
              animation_delay="1s"
            >
              <div className="e_rbox e_Rbox-000 p_rbox">
                <div className="tech_list_context reset_style">
                  <div
                    animation_name="none"
                    animation_duration="0s"
                    animation_delay="0s"
                  >
                    <p>
                      <span className="tech_lc_txt">
                        近年来，城市化迅速发展、地铁高铁等城市交通的建设、能源开采等产生了较为严重的地面沉降，影响生态环境、工程建设及居民生活等，严重制约着社会经济可持续发展。合成孔径雷达干涉测量（InSAR）作为一种监测地表形变的新技术，它可以高精度地监测大面积微小地面形变，监测精度可以达到厘米-亚厘米级，对于能源开采及城市的沉降监测，具有十分重要的意义。
                      </span>
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <span className="tech_lc_txt_t">
                        <strong>●城市地面沉降监测</strong>
                      </span>
                    </p>
                    <p>
                      <span className="tech_lc_txt">
                        城市地面沉降的主要诱因为地下水的开采和大量工程建设荷载。时序InSAR技术可以利用城市建筑等干涉时间序列上的高相干点实现对城市区域稳健且高精度的形变测量，从而获取沉降漏斗与沉降中心的分布，进而分析交通、电力等重点工程的地面沉降情况。
                      </span>
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <span className="tech_lc_txt_t">
                        <strong>●矿区开采沉降监测</strong>
                      </span>
                    </p>
                    <p>
                      <span className="tech_lc_txt">
                        人类过度开采石油、天然气、固体矿产等地下资源，使贮存这些固体、液体和气体的沉积层的孔隙压力发生趋势性的降低，有效应力增大，从而导致地层的压密，进而引发沉降灾害。通过时序InSAR技术，获取矿区的永久散射体与分布式散射体，能够对矿区进行大范围、高精度的沉降监测。
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="tect_list_name reset_style"
            comporinalwidth="488"
            comporinalleft="360"
            originaled="true"
          >
            <div
              animation_name="none"
              animation_duration="0s"
              animation_delay="0s"
            >
              <p>
                <span className="tect_ln_txt">
                  沉降监测 /&nbsp;Subsidence monitoring
                </span>
              </p>
            </div>
          </div>
          <div
            className="tech_list_pic w_img-002"
            comporinalwidth="569"
            comporinalleft="360"
            originaled="true"
          >
            <div
              animation_name="none"
              animation_duration="1s"
              animation_delay="0s"
            >
              <div className="e_box e_box-000 p_box">
                <a className="e_link e_link-000 p_link001" target="_blank">
                  <div className="e_image e_DImage-001 p_dimage">
                    <img
                      src="./img/g2f008.jpg"
                      alt=""
                      title=""
                      width="100%"
                      height="100%"
                    />
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="tech3" ref={tech3} className="techs_div">
        <div className="tech_list_item" data-animeff="linear" data-duration="1">
          <div
            className="tech_list_txt"
            data-animation="once"
            comporinalwidth="690"
            comporinalleft="869"
            originaled="true"
            animated="true"
          >
            <div
              className="tech_txt_wrap"
              animation_name="fadeInUp"
              animation_duration="1s"
              animation_delay="1s"
            >
              <div className="e_rbox e_Rbox-000 p_rbox">
                <div className="tech_list_context reset_style">
                  <div
                    animation_name="none"
                    animation_duration="0s"
                    animation_delay="0s"
                  >
                    <p>
                      <span className="tech_lc_txt">
                        土地资源是人类在地球上赖以生存最重要的资源，它不仅能够反映出一个国家或地区的地表环境等基本地理信息，还能够在一定程度上反映地区经济发展、城镇化和军事布局等状况。土地利用情况是人类和土地相互作用的综合结果，同时作为各种资源管理和地理信息服务所需要的最基本数据，对土地利用信息的分类和变化监测，显得尤为重要。卫星遥感提供了全球监测的动态信息，被认为是获取土地利用分类及变化检测最经济、快捷、有效途径。
                      </span>
                    </p>
                    <p>
                      <span className="">&nbsp;</span>
                    </p>
                    <p>
                      <span className="tech_lc_txt_t">
                        <strong>●土地利用分类</strong>
                      </span>
                    </p>
                    <p>
                      <span className="tech_lc_txt">
                        SAR能够弥补光学遥感在常年多云多雨地区数据获取问题，且具有对水体敏感、纹理信息丰富、多极化等特征，因此可以与光学影像相互配合，应用于耕地、林地、草地、水体、建设用地和其它用地6大类土地利用分类调查底图的制作，服务于土地利用分类与调查。
                      </span>
                    </p>
                    <p>
                      <span className="">&nbsp;</span>
                    </p>
                    <p>
                      <span className="tech_lc_txt_t">●土地利用变化监测</span>
                    </p>
                    <p>
                      <span className="tech_lc_txt">
                        SAR图像变化检测可以发挥其全天候、近实时监测的特点，与光学遥感形成互补，实现对土地利用和土地覆盖的变化检测，服务于国土资源调查。
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="tect_list_name reset_style"
            comporinalwidth="488"
            comporinalleft="360"
            originaled="true"
          >
            <div
              animation_name="none"
              animation_duration="0s"
              animation_delay="0s"
            >
              <p>
                <span className="tect_ln_txt">土地利用 /&nbsp;Land use</span>
              </p>
            </div>
          </div>
          <div
            className="tech_list_pic w_img-002"
            comporinalwidth="569"
            comporinalleft="360"
            originaled="true"
          >
            <div
              animation_name="none"
              animation_duration="1s"
              animation_delay="0s"
            >
              <div className="e_box e_box-000 p_box">
                <a className="e_link e_link-000 p_link001" target="_blank">
                  <div className="e_image e_DImage-001 p_dimage">
                    <img
                      src="./img/g3.jpg"
                      alt=""
                      title=""
                      width="100%"
                      height="100%"
                    />
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="tech4" ref={tech4} className="techs_div">
        <div className="tech_list_item" data-animeff="linear" data-duration="1">
          <div
            className="tech_list_txt"
            data-animation="once"
            comporinalwidth="690"
            comporinalleft="869"
            originaled="true"
            animated="true"
          >
            <div
              className="tech_txt_wrap"
              animation_name="fadeInUp"
              animation_duration="1s"
              animation_delay="1s"
            >
              <div className="e_rbox e_Rbox-000 p_rbox">
                <div className="tech_list_context reset_style">
                  <div
                    animation_name="none"
                    animation_duration="0s"
                    animation_delay="0s"
                  >
                    <p>
                      <span className="tech_lc_txt">
                        农业在中国的国民经济中起着举足轻重的作用，可是目前中国的农业还比较落后，而信息的缺乏是制约中国农业发展的瓶颈。RapidEye等多光谱卫星遥感技术能够为农业领域提供农作物识别与分类、农作物监测与产量预测、农业保险、精细农业等服务，全力服务于农村土地管理与三农信息化建设。
                      </span>
                    </p>
                    <p>
                      <span className="">&nbsp;</span>
                    </p>
                    <p>
                      <span className="tech_lc_txt_t">
                        <strong>●农作物识别与分类</strong>
                      </span>
                    </p>
                    <p>
                      <span className="tech_lc_txt">
                        不同作物在遥感影像上呈现不同的颜色、纹理、形状等特征信息，利用信息提取的方法，可以将作物种植区域提取出来，从而得到作物种植面积和种植区域。
                      </span>
                    </p>
                    <p>
                      <span className="">&nbsp;</span>
                    </p>
                    <p>
                      <span className="tech_lc_txt_t">
                        <strong>●农作物监测与产量预测</strong>
                      </span>
                    </p>
                    <p>
                      <span className="tech_lc_txt">
                        作物在红波段和近红外波段的反射特征与作物长势及作物产量具有明显的正相关关系,由这两个波段计算得到的植被指数常用于监测作物长势，进而用于估算作物产量以及诸如病虫害、肥料缺乏等胁迫反应造成的变化，包括生物化学变化(纤维素、叶片)和生物物理变化(冠层结构、覆盖、LAI)等。
                      </span>
                    </p>
                    <p>
                      <span className="">&nbsp;</span>
                    </p>
                    <p>
                      <span className="tech_lc_txt_t">
                        <strong>●农业保险</strong>
                      </span>
                    </p>
                    <p>
                      <span className="tech_lc_txt">
                        用遥感影像能够进行农业大面积灾害损失分级信息，计算评估灾害损失金额，使理赔人员能够掌握灾害损失的宏观分布情况，起到节约人力成本，提高理赔效率的作用，使保险公司免于支付高于实际损失情况的赔款。
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="tect_list_name reset_style"
            comporinalwidth="488"
            comporinalleft="360"
            originaled="true"
          >
            <div
              animation_name="none"
              animation_duration="0s"
              animation_delay="0s"
            >
              <p>
                <span className="tect_ln_txt">
                  农业应用/&nbsp;Agricultural application
                </span>
              </p>
            </div>
          </div>
          <div
            className="tech_list_pic w_img-002"
            comporinalwidth="569"
            comporinalleft="360"
            originaled="true"
          >
            <div
              animation_name="none"
              animation_duration="1s"
              animation_delay="0s"
            >
              <div className="e_box e_box-000 p_box">
                <a className="e_link e_link-000 p_link001" target="_blank">
                  <div className="e_image e_DImage-001 p_dimage">
                    <img
                      src="./img/g4.jpg"
                      alt=""
                      title=""
                      width="100%"
                      height="100%"
                    />
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="tech5" ref={tech5} className="techs_div">
        <div className="tech_list_item" data-animeff="linear" data-duration="1">
          <div
            className="tech_list_txt"
            data-animation="once"
            comporinalwidth="690"
            comporinalleft="869"
            originaled="true"
            animated="true"
          >
            <div
              className="tech_txt_wrap"
              animation_name="fadeInUp"
              animation_duration="1s"
              animation_delay="1s"
            >
              <div className="e_rbox e_Rbox-000 p_rbox">
                <div className="tech_list_context reset_style">
                  <div
                    animation_name="none"
                    animation_duration="0s"
                    animation_delay="0s"
                  >
                    <p>
                      <span className="tech_lc_txt">
                        随着雷达遥感技术不断发展，SAR在测绘方面应用逐渐成熟，制图是SAR的重要应用领域之一。目前，高分辨雷达卫星RADARSAT-2、TerraSAR等具有较高分辨率、较高轨道定位精度，在数字测图上的应用越来越广泛。
                      </span>
                    </p>
                    <p>
                      <span className="">&nbsp;</span>
                    </p>
                    <p>
                      <span className="tech_lc_txt_t">
                        <strong>●绘制地形图</strong>
                      </span>
                    </p>
                    <p>
                      <span className="tech_lc_txt">
                        利用雷达数据，基于精密轨道数据利用稀少控制和外部DEM数据可获得高精度的正射影像图，进一步用于地形图绘制。
                      </span>
                    </p>
                    <p>
                      <span className="">&nbsp;</span>
                    </p>
                    <p>
                      <span className="tech_lc_txt_t">
                        <strong>●DEM获取</strong>
                      </span>
                    </p>
                    <p>
                      <span className="tech_lc_txt">
                        利用雷达卫星数据生成DEM有以下几种方法：(1)雷达摄影测量(立体测图)，即利用视差从立体像对中得到高程，并利用三角网获得三维坐标，要求同名点配准在象素级别;(2)雷达干涉测量(InSAR)，即利用距离差和相位信息获得地表高程信息，要求同名点配准在亚象素级别。
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="tect_list_name reset_style"
            comporinalwidth="488"
            comporinalleft="360"
            originaled="true"
          >
            <div
              animation_name="none"
              animation_duration="0s"
              animation_delay="0s"
            >
              <p>
                <span className="tect_ln_txt">
                  数字测图 /&nbsp;Digital mapping
                </span>
              </p>
            </div>
          </div>
          <div
            className="tech_list_pic w_img-002"
            comporinalwidth="569"
            comporinalleft="360"
            originaled="true"
          >
            <div
              animation_name="none"
              animation_duration="1s"
              animation_delay="0s"
            >
              <div className="e_box e_box-000 p_box">
                <a className="e_link e_link-000 p_link001" target="_blank">
                  <div className="e_image e_DImage-001 p_dimage">
                    <img
                      src="./img/g5.jpg"
                      alt=""
                      title=""
                      width="100%"
                      height="100%"
                    />
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="tech6" ref={tech6} className="techs_div">
        <div className="tech_list_item" data-animeff="linear" data-duration="1">
          <div
            className="tech_list_txt"
            data-animation="once"
            comporinalwidth="690"
            comporinalleft="869"
            originaled="true"
            animated="true"
          >
            <div
              className="tech_txt_wrap"
              animation_name="fadeInUp"
              animation_duration="1s"
              animation_delay="1s"
            >
              <div className="e_rbox e_Rbox-000 p_rbox">
                <div className="tech_list_context reset_style">
                  <div
                    animation_name="none"
                    animation_duration="0s"
                    animation_delay="0s"
                  >
                    <p>
                      <span className="tech_lc_txt">
                        遥感图像可以快速获取大范围的地表信息，因此在灾害等应急响应事件中可以发挥十分重要的作用。多时相SAR数据不仅可以反映地物的后向散射变化信息，还能获取地表形变，对于地质灾害的应急响应具有独特的优势。同时，SAR图像对水体信息较为敏感，因此可以服务于堰塞湖、洪水等灾害的监测。
                      </span>
                    </p>
                    <p>
                      <span className="">&nbsp;</span>
                    </p>
                    <p>
                      <span className="tech_lc_txt_t">
                        <strong>●地质灾害应急响应</strong>
                      </span>
                    </p>
                    <p>
                      <span className="tech_lc_txt">
                        多时相SAR数据进行干涉处理能够测量地震、山体滑坡等造成的形变，同时还能够通过强度获取建筑物、道路的变化信息，监测震后堰塞湖的水位变化信息等，可为理解发震构造和灾害程度，指导救援决策提供重要的数据和技术保障。
                      </span>
                    </p>
                    <p>
                      <span className="">&nbsp;</span>
                    </p>
                    <p>
                      <span className="tech_lc_txt_t">
                        <strong>●气象灾害应急响应</strong>
                      </span>
                    </p>
                    <p>
                      <span className="tech_lc_txt">
                        SAR凭借其全天时、全天候、大幅宽的优势及特殊的成像机理，目前已成为暴雨洪涝灾害、海上台风等气象灾害监测的重要手段之一。利用多时相的SAR图像，可以监测水体面积的变化，还可以对台风风眼进行持续跟踪拍摄，为气象灾害的预警和应急提供决策支持。
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="tect_list_name reset_style"
            comporinalwidth="488"
            comporinalleft="360"
            originaled="true"
          >
            <div
              animation_name="none"
              animation_duration="0s"
              animation_delay="0s"
            >
              <p>
                <span className="tect_ln_txt">
                  应急响应 /&nbsp;Emergency Response
                </span>
              </p>
            </div>
          </div>
          <div
            className="tech_list_pic w_img-002"
            comporinalwidth="569"
            comporinalleft="360"
            originaled="true"
          >
            <div
              animation_name="none"
              animation_duration="1s"
              animation_delay="0s"
            >
              <div className="e_box e_box-000 p_box">
                <a className="e_link e_link-000 p_link001" target="_blank">
                  <div className="e_image e_DImage-001 p_dimage">
                    <img
                      src="./img/g6.jpg"
                      alt=""
                      title=""
                      width="100%"
                      height="100%"
                    />
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {domId && <RightAnchor domId={domId} />}
    </div>
  );
}
